import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/laravel': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M637.5 241.6C633.3 236.8 574.7 163.5 564.4 151.1 554.1 138.7 549 140.9 542.7 141.8 536.3 142.7 462.2 155.2 453.6 156.6 445 158.1 439.6 161.5 444.9 168.9 449.6 175.5 498.3 244.6 509.1 259.8L315.4 306.2 161.2 48.7C155.1 39.6 153.8 36.4 139.8 37.1 125.8 37.7 18.9 46.6 11.3 47.3 3.7 47.9-4.7 51.3 2.9 69.3S131.9 348.9 135.3 356.5C138.7 364.1 147.5 376.5 168.1 371.5 189.2 366.4 262.4 347.3 302.4 336.8 323.5 375.1 366.6 452.7 374.6 463.8 385.2 478.7 392.6 476.2 408.9 471.2 421.7 467.3 608.5 400.1 616.9 396.7 625.3 393.2 630.5 390.8 624.8 382.3 620.6 376.1 571.3 310.1 545.5 275.5 563.2 270.8 626.1 254.1 632.8 252.2 640.7 250.2 641.8 246.4 637.5 241.6zM285.3 313.6C283 314.1 174.5 340.1 168.7 341.4 162.9 342.7 162.9 342.1 162.2 340.1 161.5 338.1 33.2 73.4 31.4 70.1 29.6 66.8 29.7 64.2 31.4 64.2S133.9 55.2 137.4 55C141 54.8 140.6 55.6 141.9 57.8 141.9 57.8 284.1 303.2 286.5 307.5 289.1 311.8 287.6 313.1 285.3 313.6zM591.3 371C593 373.7 594.8 375.5 589.3 377.4 583.9 379.4 405.6 439.5 402.2 441 398.7 442.5 396 443 391.6 436.5S329.2 329.7 329.2 329.7L518 280.6C522.7 279.1 524.2 278.1 527.2 282.8 530.1 287.6 589.6 368.3 591.3 371zM603.4 236.9C599.2 237.8 529.8 255 529.8 255L473.1 177.2C471.5 174.9 470.2 172.7 474.2 172.2S542.6 160 545.5 159.4C548.4 158.7 550.9 157.9 554.5 162.8 558.1 167.7 607.1 229.8 609 232.2 610.8 234.5 607.6 235.9 603.4 236.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/laravel.js
// module id = iNoq
// module chunks = 144